import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { getTestIds } from '../../../../utils/TestIds';
import { Typography } from '../../../Typography';
import { SchemaCell } from '../cells/SchemaCell/SchemaCell';
import { cardCellEditing, columnName, isCellValuePresent, movesSubtitleOut, showsOwnValue } from '../mobileCard/mobileCard';
import styles from '../table.module.scss';
export function CardFieldValue(param) {
    let { field, row, now, pending, editing, cardTestId } = param;
    const cardTestIds = getTestIds(cardTestId);
    const isStrong = field.emphasis === 'strong';
    const cell = (column, param)=>{
        let { showsSubtitle } = param;
        const name = columnName(column);
        return /*#__PURE__*/ _jsx(SchemaCell, {
            skin: isStrong ? undefined : 'secondary',
            weight: isStrong ? 'normal' : undefined,
            column: column,
            showsSubtitle: showsSubtitle,
            row: row,
            now: now,
            pending: pending && column.showsLoaderWhilePending === true,
            editing: cardCellEditing(editing, column),
            testId: cardTestIds.value(name)
        });
    };
    // WHY: with nothing to join, a row reads exactly like the same field without a join, empty form included.
    if (field.joined == null || !isCellValuePresent(row, field.joined)) {
        return cell(field.column, {
            showsSubtitle: !movesSubtitleOut(field)
        });
    }
    const showsOwn = showsOwnValue(field, row);
    // WHY: a joined row reads as one line, so neither value brings its second line.
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.joinedCardValue,
        children: [
            showsOwn && cell(field.column, {
                showsSubtitle: false
            }),
            showsOwn && /*#__PURE__*/ _jsx(Typography, {
                skin: "secondary",
                testId: cardTestIds.separator(columnName(field.column)),
                children: "•"
            }),
            cell(field.joined, {
                showsSubtitle: false
            })
        ]
    });
}
